import React from 'react';
import { useSelector } from 'react-redux';

import { UserHeader } from 'components/common/Header';
import RenderComponent from 'components/common/RenderComponent';
import { CreatingOrderSelectors } from 'store/selectors';
import { makeStyles } from 'tss-react/mui';

export interface CreatingOrderLayoutProps {
  frame?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  mobileTop: {
    [theme.breakpoints.down('sm')]: {
      position: 'sticky',
      top: 0,
      width: '100%',
      zIndex: 200,
    },
  },
}));

const CreatingOrderLayout: React.FC<React.PropsWithChildren<CreatingOrderLayoutProps>> = (props) => {
  const { isLoading, frame, children } = props;
  const { classes } = useStyles();
  const isEmbedded = useSelector(CreatingOrderSelectors.getIsEmbedded);
  return (
    <>
      {!(frame || isEmbedded) && (
        <div className={classes.mobileTop}>
          <UserHeader hasSearch={false} hasMarketSelect={false} />
        </div>
      )}
      <RenderComponent layout isLoading={isLoading} renderContent={() => children} />
    </>
  );
};

export default CreatingOrderLayout;
